import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, YouTubeIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Youtube } from 'almanac-ui/icons'
import { CardButtons } from './CardButtons'
import { useModals } from 'almanac-ui/Modal'
import YouTubeInitialization from 'components/IntegrationInitialization/YouTubeInitialization/YouTubeInitialization'

export const YouTubeCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: YouTubeIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  return (
    <ExternalIntegrationCard
      title={'YouTube'}
      description={'Post directly to your YouTube channel'}
      integrations={integrations}
      icon={<Youtube size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(YouTubeInitialization)}
          provider={ExternalIntegrationEnum.YouTube}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
